import { h, Fragment, Component } from "preact";
import { useMemo, useEffect } from 'preact/hooks'
import { observer } from "mobx-react";
import { withStore } from "@searchspring/snap-preact-components";
import "./Header.css";
import { Tabs } from "../Tabs/Tabs";

@withStore
@observer
export class Header extends Component {
  render() {
    const { pagination, search } = this.props.store;

    return (
      <>
        {pagination.totalResults === 0 ? (
          <header class="ss-header-container ss-header-results-not-found">
            <h2 class="ss-title ss-results-title ss-no-results-title headline headline-medium">
              {search?.query &&
                <>
                  {window.Resources.searchspring.results.noResultsHeading}
                  <span class="ss-results-query">
                    <br/>{search.query.string}
                  </span>
                  <span class="ss-results-header-body body-medium">
                    {window.Resources.searchspring.results.noResultsCallToAction}
                  </span>
                </>
              }
            </h2>
            <Tabs tabs={this.props.tabs}/>
          </header>
        ) : pagination.totalResults && pagination.totalResults > 0 ? (
          <header class="ss-header-container ss-header-results-found">
            <h2 class="ss-title ss-results-title headline headline-medium">
              {window.Resources.searchspring.results.resultsHeading}
              {search?.query && (
                <span class="ss-results-query">
                  <br/>{search.query.string}
                </span>
              )}
            </h2>
            <Tabs tabs={this.props.tabs}/>
          </header>
        ) : null}
      </>
    )
    
  }
}
